// extracted by css-extract-rspack-plugin
export default {"loading":"XIqMke6KaNYLtItf"};